import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

import type { DominationState } from "./use-domination-data";
import { WorldDominationMap } from "./world-domination-map";

export const WorldDominationCard = ({
  state,
  className,
}: {
  state: DominationState;
  className?: string;
}) => {
  const { data, youUid, isLoading, isError } = state;
  const empty = !isLoading && (!data || data.grandTotal === 0);

  return (
    <Card className={className}>
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
        <div>
          <CardTitle className="text-base flex items-center gap-2">
            🌍 World domination
          </CardTitle>
          <CardDescription>All-time HITL conquests by curator</CardDescription>
        </div>
        {data && data.grandTotal > 0 && (
          <Badge variant="outline" className="text-xs">
            {data.grandTotal.toLocaleString()} total resolves
          </Badge>
        )}
      </CardHeader>
      <CardContent className="pb-2">
        {isLoading ? (
          <Skeleton className="h-[300px] w-full" />
        ) : isError ? (
          <div className="flex h-[300px] items-center justify-center text-xs text-muted-foreground">
            Couldn't load domination data.
          </div>
        ) : empty ? (
          <div className="flex h-[300px] flex-col items-center justify-center gap-1 text-center">
            <div className="text-2xl">🗺️</div>
            <div className="text-sm font-medium">No territory claimed yet</div>
            <div className="text-xs text-muted-foreground">
              Resolve your first HITL to plant a flag.
            </div>
          </div>
        ) : (
          <WorldDominationMap
            countries={data!.countries}
            youUid={youUid}
            colorByUid={data!.colorByUid}
          />
        )}
      </CardContent>
      <div
        className={cn(
          "flex items-center justify-between px-6 pb-3",
          "text-[11px] text-muted-foreground",
        )}
      >
        <span>
          scroll to zoom · drag to pan · bubble = country leader · hover for the
          full breakdown
        </span>
        <span>
          {data ? `${data.countries.length} countries dominated` : ""}
        </span>
      </div>
    </Card>
  );
};
